import { jsx, Fragment } from "react/jsx-runtime";
import { Children } from "react";
import { SpaceMd } from "@nxt-costco-com/forge-design-tokens";
import { CostcoBox } from "../../../../Util/CostcoBox.js";
const OneSixth = ({
  children
}) => {
  return /* @__PURE__ */ jsx(Fragment, { children: Children.map(children, (child, index) => {
    return /* @__PURE__ */ jsx(
      CostcoBox,
      {
        sx: {
          display: "flex",
          flex: {
            md: `calc(${100 / 6}% - 13.33px)`,
            xs: `calc(50% - ${SpaceMd})`
          },
          maxWidth: {
            md: `calc(${100 / 6}% - 13.33px)`,
            xs: `calc(50% - ${SpaceMd})`
          }
        },
        children: child
      },
      index
    );
  }) });
};
export {
  OneSixth
};
